import React from "react";
import HomeCorousel from "../components/Corousel/HomeCorousel";
import WeekendOffer from "../components/Ads/WeekendOffer";
import SwipeToSlide from "../components/Corousel/SwipeToSlide";
import Topdeals from "../components/layout/Topdeals";
import Shopfromcategory from "../components/Container/Shopfromcategory";
import BigAnnounce from "../components/Container/BigAnnounce";
import Navbar from "./Navbar";
import Footer from "../components/layout/Footer";
const Home = () => {
  return (
    <div>
      <Navbar />
      <HomeCorousel />
      <WeekendOffer />
      <SwipeToSlide />
      <Topdeals />
      <Shopfromcategory />
      <BigAnnounce />
      <Footer />
    </div>
  );
};

export default Home;
